// @ts-strict-ignore
import * as React from 'react';

import {isProperty} from 'common/query-builder/query-block/properties-menu/types';
import {SelectReact} from 'common/components/select';
import {ButtonSize} from 'common/components/button/constants';
import {SelectTheme} from 'common/components/select/constants';
import {Behavior} from 'common/types/reports/query';
import {DEFAULT_REVENUE_CHANGE_BEHAVIOR} from 'common/query-builder/query-entry-section/row-types/behavior/utils';

import {Offset} from '../offset';
import styles from './index.module.styl';
import {REVENUE_CHANGE_TYPES} from './constants';

function RevenueChange({behavior, onChange}: {behavior: Behavior; onChange: (behavior: Behavior) => void}) {
  const changeType = behavior.changeType;
  return (
    <>
      <Offset
        value={behavior.offset}
        onChange={(offset) => {
          onChange({
            ...behavior,
            offset,
          });
        }}
      />
      {behavior.behaviorType === DEFAULT_REVENUE_CHANGE_BEHAVIOR.behaviorType && (
        <div className={styles.changeType}>
          <div className={styles.text}>Change Type is</div>
          <SelectReact
            theme={SelectTheme.QbSubitem}
            size={ButtonSize.Small}
            menuWidth={140}
            onChange={({detail: {item}}) => {
              onChange({
                ...behavior,
                changeType: item.value,
              });
            }}
            sections={[
              {
                // remove `flat` in the rev change
                items: REVENUE_CHANGE_TYPES.filter((revenueChangeType) => revenueChangeType.value !== `flat`).map(
                  (item) => ({
                    isSelected: changeType === item.value,
                    label: item.label,
                    value: item.value,
                  }),
                ),
              },
            ]}
          />
        </div>
      )}
    </>
  );
}
/**
 * Revenue block is displayed when "Recurring Revenue Change" (computed property) is selected
 */
export function RevenueChangeBlock(props: {behavior: Behavior; onChange: (behavior: Behavior) => void}) {
  if (!isProperty(props.behavior?.property)) {
    return null;
  }
  if (!props.behavior?.offset) {
    return null;
  }

  return (
    <RevenueChange
      behavior={props.behavior}
      onChange={(changedBehavior) => {
        props.onChange(changedBehavior);
      }}
    />
  );
}
